// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"451":"02abfafa","951":"54fe650e"}[chunkId] + ".css";
};